var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 25a4 4 0 0 1 4-4h7v25H4V25Z",
    fill: "#985184"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 8c0-2.21 1.876-4 4.19-4H46v38c0 2.21-1.876 4-4.19 4H26V8Z",
    fill: "#FBB945"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.067C15 14.821 16.876 13 19.19 13H35v28.933C35 44.179 33.124 46 30.81 46H15V17.067Z",
    fill: "#FC868B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 46h4.81c2.314 0 4.19-1.821 4.19-4.067V13h-9v33Z",
    fill: "#F86126"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m15 46 4.995-.002A4.005 4.005 0 0 0 24 41.995V21h-9v25Z",
    fill: "#962B48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/Sales.b8a3896ca15f6a269ec30b2f7f114aec.svg";
export { ForwardRef as ReactComponent };